import React from 'react';
import { FaBullseye } from 'react-icons/fa';

/**
 * BullseyeIcon
 * Jednotný komponent pre ikonu terča používanú pri označení tombolových akcií.
 * Komponent umožňuje doplnenie vlastných CSS tried cez prop `className`.
 */
const BullseyeIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FaBullseye className={className} {...props} />
);

export default BullseyeIcon;

